<template>
  <div class="Lancamentos">
    <div class="Lancamentos_header mb-3">
      <div class="row px-2 pt-2">
        <div class="col-4 form-group"
             :class="{'mr-5': errors.has('fim')}">
          <label for="data"
                 class="Lancamentos_header_label m-0 p-0 mb-1">Período</label>
          <div id="data"
               class="d-inline-flex align-items-top">
            <div class="form-group m-0 p-0">
              <CustomInput
                name="data_inicial"
                type="date"
                :initial-value="localData.data_inicial"       
                @blur="setValueInput" />
            </div>
            <p class="p-0 m-0 mx-2 mt-1 Lancamentos_header_label">
              até
            </p>
            <div class="form-group m-0 p-0">
              <CustomInput
                name="data_final"
                type="date"
                :initial-value="localData.data_final"   
                @blur="setValueInput" />
            </div>
          </div>
        </div>
        <div class="col-3">
          <label for="tipo"
                 class="Lancamentos_header_label m-0 p-0 mb-1">Tipo de lançamento</label>
          <CustomCheckBox class="mr-3"
                          :is-multi="true"
                          :options="checkboxOptions"
                          @onChange="(ev) => changeTipo(ev)" />
        </div>
      </div>
      <div class="row align-items-end px-2">
        <div class="col-5">
          <label for="tipo"
                 class="Lancamentos_header_label m-0 p-0 mb-1">Perquisar por</label>
          <CustomInput
            name="filtros"
            type="text"  
            :initial-value="filtros"
            disabled
            @blur="(name, value) => filtros = value" />
        </div>
        <div class="mr-3">
          <CustomButton variant="outline-primary"
                        :disabled="localData.tipo === 'TODOS'"
                        text="Filtros Avançados"
                        @click="showFilters = true" />
        </div>
        <div>
          <CustomButton variant="secondary"
                        text="Listar"
                        @click="getLancamentos" />
        </div>
      </div>
      <hr>
      <div class="row">
        <div class="col-6">
          <CustomButton variant="primary"
                        @click="showFormLancamento = true">
            <div class="flex justify-content-between align-items-center">
              <IconSvg class="icon-add mr-1"
                       
                       icon="add" />
              Novo Lançamento
            </div>
          </CustomButton>
        </div>
        <div class="col-6">
          <div class="row justify-content-end mr-1">
            <button class="btn_print btn btn-sm btn-outline-primary"
                    @click="showImpressao()">
              <icon-svg icon="print"
                        class="icon-print icon--xs mr-1" />
              Imprimir
            </button>
          </div>
        </div>
      </div>
    </div>

    <div v-if="lancamentos.length"
         class="Lancamentos">
      <div class="Lancamentos_body">
        <ListagemLancamentos :prop-lancamentos="lancamentos"
                             :prop-totais="totais"
                             @showDetalhes="showDetalhes"
                             @deleteLancamento="deleteLancamento" />
        <Pagination
          :per-page="perPage"
          :page="page"
          :last-page="lastPage"
          :select-page="true"
          class="mt-2"
          @onPreviousPage="reloadLancamentos(true, page - 1)"
          @onNextPage="reloadLancamentos(true, page + 1)" />
      </div>
    </div>
    <FiltrosAvancados v-if="showFilters"
                      :prop-filtros="filtrosSelected"
                      :prop-tipo="localData.tipo"
                      :prop-fornecedores="fornecedores"
                      :prop-categorias="categorias"
                      @getFilters="getFilters"
                      @hide="showFilters = false" />

    <FormLancamento v-if="showFormLancamento"
                    :prop-lancamento="lancamento"
                    :prop-fornecedores="fornecedores"
                    :prop-categorias="categorias"
                    @saveLancamento="saveLancamento"
                    @atualizarLancamento="atualizarLancamento"
                    @reloadBeneficiarios="getFornecedores()"
                    @hide="hideForm()" />

    <LancamentoDetalhes v-if="showModalDetalhes"
                        :prop-lancamento="lancamento"
                        @hide="hideDetalhes()"
                        @editar="editarLancamento" />

    <Impressao v-if="showModalImpressao"
               :prop-data="localData"
               @showImpressao="showImpressao"
               @hide="hideImpressao()" />
  </div>
</template>

<script>
  // Components
  import ListagemLancamentos from "./ListagemLancamentos"
  import FiltrosAvancados from "./FiltrosAvancados"
  import FormLancamento from "./FormLancamento"
  import LancamentoDetalhes from "./LancamentoDetalhes"
  import Pagination from "@/components/SofiaRei/Pagination"
  import Impressao from '@/components/LivroCaixa/ImpressaoLivroCaixa'
  import CustomInput from '@/components/CustomInputs/CustomInput'
  import CustomButton from '../CustomButton/CustomButton'
  import CustomCheckBox from "../CustomInputs/CustomCheckBox"

  // Services
  import CategoriaService from "@/services/CategoriaService"
  import FornecedorService from "@/services/FornecedorService"
  import LivroCaixaService from "@/services/LivroCaixaService"

  // outros
  import moment from 'moment'


  export default {
    name: 'Lancamentos',
    components: {
      ListagemLancamentos,
      FiltrosAvancados,
      FormLancamento,
      LancamentoDetalhes,
      Pagination,
      Impressao,
      CustomInput,
      CustomButton,
      CustomCheckBox
    },
    data () {
      return {
        localData: {
          data_inicial: null,
          data_final: null,
          tipo: []
        },
        checkboxOptions: [
          { item: 'RECEITA', name: 'Receita' },
          { item: 'DESPESA', name: 'Despesa' },
        ],
        search: {},
        filtros: null,
        filtrosSelected: null,
        showFilters: false,
        showFormLancamento: false,
        showModalDetalhes: false,
        showModalImpressao: false,
        lancamentos: [],
        lancamento: null,
        fornecedores: [],
        categorias: [],
        page: 1,
        lastPage: 1,
        perPage: 20,
        totais: []
      }
    },
    mounted () {
      this.init()
    },
    methods: {
      init () {
        const firstDay = moment().startOf('month').format('YYYY-MM-DD')
        const lastDay = moment().endOf('month').format('YYYY-MM-DD')

        this.localData.data_inicial = firstDay
        this.localData.data_final = lastDay

        this.getLancamentos()
        this.getCategorias()
        this.getFornecedores()
      },
      setValueInput (nome, value) {     
        this.localData[nome] = value
      },
      handleTipoLancamento (ev) {
        console.log(ev)
      },
      async getLancamentos () {
        const valid = await this.$validator.validateAll()

        if (!valid) return
        try {
          loader({active: true, text: 'Buscando lançamentos'})

          const params = {
            ...this.localData,
            page: 1,
            perPage: this.perPage,
            orderBy: this.orderBy
          }

          this.search = {...params}

          const res = await LivroCaixaService.getLancamentos(params)
          res.data = res.data.filter(({ordemServicoItem}) => !!ordemServicoItem ? ordemServicoItem.ordemServico.valor_total != 0 : ordemServicoItem == null)

          if (res && res.data && res.data.length) {
            this.lancamentos = res.data
            this.totais = res.totais
            this.page = res.page
            this.lastPage = res.lastPage
            this.perPage = res.perPage
          } else {
            this.lancamentos = []

            return displayMessage('error', 'Nenhum lançamento encontrado!')
          }
        } catch (error) {
          const message = getErrors(error)

          displayMessage('error', 'Erro!', message.message)
        } finally {
          loader({active: false, text: ''})
        }
      },
      async reloadLancamentos (loaderActive = true, page = 1) {
        try {
          loader({active: loaderActive, text: 'Buscando lançamentos'})
          const params = {
            ...this.search,
            page,
            perPage: this.perPage,
            orderBy: this.orderBy
          }

          const res = await LivroCaixaService.getLancamentos(params)
          res.data = res.data.filter(({ordemServicoItem}) => !!ordemServicoItem ? ordemServicoItem.ordemServico.valor_total != 0 : ordemServicoItem == null)

          if (res && res.data && res.data.length) {
            this.lancamentos = res.data
            this.page = res.page
            this.lastPage = res.lastPage
            this.perPage = res.perPage
          } else if (page > 1) {
            this.reloadLancamentos(true, this.page - 1)
          } else  {
            this.lancamentos = []
            this.page = 1
            this.lastPage = 1

            return displayMessage('error', 'Nenhum lançamento encontrado!')
          }
        } catch (error) {
          const message = getErrors(error)

          displayMessage('error', 'Erro!', message.message)
        } finally {
          loader({active: false, text: ''})
          this.scrollList()
        }
      },
      getFilters (filters) {
  
        this.localData = {
          ...this.localData,
          ...filters
        }

        this.filtros = {}
        this.filtrosSelected = filters

        if (filters.categoria_id) {
          const categoria = this.categorias.find(categoria => categoria.categoria_id === filters.categoria_id)
          this.filtros.categoria = categoria.nome
        }

        if (filters.fornecedor_id) {
          const fornecedor = this.fornecedores.find(fornecedor => fornecedor.fornecedor_id === filters.fornecedor_id)
          this.filtros.fornecedor = fornecedor.nome
        }

        this.filtros = JSON.stringify(this.filtros).replace(/\{|}|"/g,'').toLowerCase()

        this.showFilters = false
      },
      async saveLancamento (lancamento, hide = false) {
        try {
          loader({active: true, text: 'Cadastrando Lançamento'})
          const res = await LivroCaixaService.cadastrarLancamento(lancamento)

          if (hide && res) {
            this.showFormLancamento = false
            return displayMessage('success', 'Lançamento cadastrado com sucesso!').then(() => {
              this.reloadLancamentos(true, this.page)
              this.getCategorias(false)
              this.getFornecedores(false)
            })
          } else if (res) {
            this.$toast.success('Lançamento cadastrado com sucesso!', {
              position: 'top-right',
              duration: 5000
            })

            this.reloadLancamentos(false, this.page)
            this.getCategorias(false)
            this.getFornecedores(false)
          }
        } catch (error) {
          const message = getErrors(error)

          displayMessage('error', 'Erro!', message.message)
        } finally {
          loader({active: false, text: ''})
        }
      },
      async atualizarLancamento (lancamento) {
        try {
          loader({active: true, text: 'Atualizando Lançamento'})
          const res = await LivroCaixaService.atualizarLancamento(lancamento, lancamento.livro_caixa_lancamento_id)

          if (res) {
            this.showFormLancamento = false
            return displayMessage('success', 'Lançamento atualizado com sucesso!').then(() => {
              this.reloadLancamentos(true, this.page)
              this.getCategorias(false)
              this.getFornecedores(false)
            })
          }
        } catch (error) {
          const message = getErrors(error)

          displayMessage('error', 'Erro!', message.message)
        } finally {
          loader({active: false, text: ''})
        }
      },
      async deleteLancamento (lancamento) {
        try {
          loader({active: true, text: 'Excluindo Lançamento'})
          const res = await LivroCaixaService.excluirLancamento(lancamento.livro_caixa_lancamento_id)

          if (res) {
            return displayMessage('success', 'Lançamento excluido com sucesso!').then(() => {
              this.reloadLancamentos(false, this.page)
            })
          }
        } catch (error) {
          const message = getErrors(error)

          displayMessage('error', 'Erro!', message.message)
        } finally {
          loader({active: false, text: ''})
        }
      },
      async getCategorias (showLoader = true) {
        try {
          loader({active: showLoader, text: 'Buscando categorias...'})

          const res = await CategoriaService.getCategorias({group_by_nome: false})

          if (res) {
            this.categorias = res
          }
        } catch (error) {
          const message = getErrors(error)

          displayMessage('error', 'Erro!', message.message)
        } finally {
          loader({active: false, text: null})
        }
      },
      async getFornecedores (showLoader = true) {
        try {
          loader({active: showLoader, text: 'Buscando fornecedores...'})

          const res = await FornecedorService.getFornecedores()

          if (res) {
            this.fornecedores = res
          }
        } catch (error) {
          const message = getErrors(error)

          displayMessage('error', 'Erro!', message.message)
        } finally {
          loader({active: false, text: null})
        }
      },
      showDetalhes (lancamento) {
        this.lancamento = lancamento
        this.showModalDetalhes = true
      },
      editarLancamento (lancamento) {
        this.lancamento = lancamento
        this.showFormLancamento = true
        this.showModalDetalhes = false
      },
      hideForm () {
        this.showFormLancamento = false
        this.lancamento = null
      },
      hideDetalhes () {
        this.lancamento = null
        this.showModalDetalhes = false
      },
      hideImpressao () {
        this.lancamento = null
        this.showModalImpressao = false
      },
      changeTipo (arrTipo) {
        if (arrTipo.length) this.localData.tipo = arrTipo
        else this.localData.tipo = []
        this.filtrosSelected = null,
        this.filtros = null
      },
      scrollList () {
        setTimeout(() => {
          const listagem = document.querySelectorAll('#inicio')

          if (listagem.length) {
            listagem[0].scrollIntoView({ behavior: 'smooth', block: 'start', inline: "start" })
          }
        }, 100)
      },
      showImpressao () {
        this.lancamento = null
        this.showModalImpressao = true
      },
    }
  }
</script>

<style lang="scss">
  .Lancamentos {
    &_header{
      &_label {
        font-size: 15px;
        font-weight: 500;
        color: #373a3c;
      }
    }

    &_despesas {
      &_header{
        background: #eaeaea;
        padding: 10px;
        font-size: 18px;
        font-weight: bold;
      }
    }

    &_receitas {
      &_header{
        background: #eaeaea;
        padding: 10px;
        font-size: 18px;
        font-weight: bold;
      };
    }
  }

  .icon-add {
    fill: #fff !important;
    width: 18px;
    height: 18px;
  }
  .icon-print {
    fill: #1c7af5 !important;
    width: 18px;
    height: 18px;
    transition: fill 0.2s;
  }
  .btn_print:hover:not(:disabled) > [class*=icon-print] {
    fill: #fff !important;
  }
  .modalImpressao{
    &_title{
    background-color: #074f7f;
    color: #fff;
    font-size: 1.5rem;
    font-weight: 500;
    padding: 0.625rem 1.25rem;
    }

    &_header{
      padding: 0 0;
    }
  }
</style>
